// Settle — central tunables.
// Board is 10 wide × 20 visible + 20 vanish/buffer (standard guideline).

export const BOARD_WIDTH = 10;
export const BOARD_VISIBLE_HEIGHT = 20;
export const BOARD_BUFFER_HEIGHT = 20; // hidden rows above the visible field for spawn / overflow
export const BOARD_TOTAL_HEIGHT = BOARD_VISIBLE_HEIGHT + BOARD_BUFFER_HEIGHT;

export const NEXT_QUEUE_LENGTH = 5;

// Lock delay (ms) with reset on move/rotate (Guideline default ~500ms, but more responsive
// games use 500ms with a cap of 15 resets).
export const LOCK_DELAY_MS = 500;
export const LOCK_RESET_MAX = 15;

// Spawn / gravity defaults (guideline marathon level-1 gravity).
export const DEFAULT_GRAVITY_G = 1 / 60; // cells per frame at 60 Hz baseline

// Soft drop / hard drop scoring per cell.
export const SOFT_DROP_SCORE_PER_CELL = 1;
export const HARD_DROP_SCORE_PER_CELL = 2;

// Score table (guideline). T-spin entries differentiate full vs mini.
export const BASE_LINE_SCORE: Record<string, number> = {
  single: 100,
  double: 300,
  triple: 500,
  tetris: 800,
  tspin: 400,
  tspin_single: 800,
  tspin_double: 1200,
  tspin_triple: 1600,
  mini_tspin: 100,
  mini_tspin_single: 200,
  mini_tspin_double: 400,
  perfect_clear_single: 800,
  perfect_clear_double: 1200,
  perfect_clear_triple: 1800,
  perfect_clear_tetris: 2000,
  back_to_back_perfect_clear_tetris: 3200,
};

export const COMBO_BONUS_PER = 50; // score: combo * 50 * level

export const LINES_PER_LEVEL = 10;

// Input default tuning (milliseconds).
export const DEFAULT_DAS_MS = 130;
export const DEFAULT_ARR_MS = 16;
export const DEFAULT_SOFT_DROP_FACTOR = 30; // multiplier vs normal gravity (Infinity = instant)
export const DEFAULT_DCD_MS = 0; // direction change delay

export const GAME_OVER_TOPOUT_REASON = 'topout' as const;

// Rendering — logical cell size; the renderer scales this up to fit the viewport.
export const CELL_PX = 32;

// Frame timing — fixed-timestep updates for deterministic physics + uncapped rendering.
export const TICK_HZ = 240;
export const TICK_MS = 1000 / TICK_HZ;

export const APP_NAME = 'Settle';
export const APP_DISPLAY = 'SETTLE';   // monospace caps version used in headers
export const APP_VERSION = '0.2.0-alpha.1';
export const STORAGE_PREFIX = 'settle:';
